








import Vue from 'vue'
import EventContainer from '@/containers/Event/Event'
import LoadEventHomeUseCase from '@/usecases/event/LoadEventHomeUseCase'
import FetchEventUseCase from '@/usecases/event/FetchEventUseCase'
import FetchEventAlbumsUseCase from '@/usecases/event/FetchEventAlbumsUseCase'
import FetchEventsBySchoolsUseCase from '@/usecases/event/FetchEventsBySchoolsUseCase'
import SearchEventUchinokoPhotosUseCase from '@/usecases/event/SearchEventUchinokoPhotosUseCase'
import FetchGroupsUseCase from '@/usecases/group/FetchGroupsUseCase'
import FetchSchoolsUseCase from '@/usecases/school/FetchSchoolsUseCase'
import FetchGroupSettingUseCase from '@/usecases/group/FetchGroupSettingUseCase'
import FetchChildrenUseCase from '@/usecases/child/FetchChildrenUseCase'
import FetchCartQueryStatusUseCase from '@/usecases/event/FetchCartQueryStatusUseCase'
import SearchEventCartQueryPhotosUseCase from '@/usecases/event/SearchEventCartQueryPhotosUseCase'
import { ErrorType, NotFoundError } from '@/common/errors'

export default Vue.extend({
  components: {
    EventContainer
  },
  middleware: ['requireAuth'],
  async fetch(ctx) {
    const { $snapsnapGateway, $eventRepository, $groupRepository, params, error } = ctx
    try {
      const eventId = parseInt(params['eventId'], 10)
      const usecaseParams = {
        snapsnapGateway: $snapsnapGateway,
        eventRepository: $eventRepository
      }
      const loadEventHomeUsecase = new LoadEventHomeUseCase({
        fetchEventUseCase: new FetchEventUseCase(usecaseParams),
        fetchEventAlbumsUseCase: new FetchEventAlbumsUseCase(usecaseParams),
        searchEventUchinokoPhotosUseCase: new SearchEventUchinokoPhotosUseCase(usecaseParams),
        fetchGroupsUseCase: new FetchGroupsUseCase({
          snapsnapGateway: $snapsnapGateway,
          groupRepository: $groupRepository
        }),
        fetchSchoolsUseCase: new FetchSchoolsUseCase({
          snapsnapGateway: $snapsnapGateway,
          groupRepository: $groupRepository
        }),
        fetchGroupSettingUseCase: new FetchGroupSettingUseCase({
          snapsnapGateway: $snapsnapGateway,
          groupRepository: $groupRepository
        }),
        fetchChildrenUseCase: new FetchChildrenUseCase({
          snapsnapGateway: $snapsnapGateway,
          groupRepository: $groupRepository
        }),
        fetchEventsBySchoolsUseCase: new FetchEventsBySchoolsUseCase({
          snapsnapGateway: $snapsnapGateway,
          eventRepository: $eventRepository
        }),
        fetchCartQueryStatusUseCase: new FetchCartQueryStatusUseCase({
          snapsnapGateway: $snapsnapGateway,
          eventRepository: $eventRepository
        }),
        searchEventCartQueryPhotosUseCase: new SearchEventCartQueryPhotosUseCase({
          snapsnapGateway: $snapsnapGateway,
          eventRepository: $eventRepository
        }),
        groupRepository: $groupRepository,
        eventRepository: $eventRepository
      })
      await loadEventHomeUsecase.execute(eventId)
    } catch (e) {
      if (e instanceof NotFoundError) {
        error({ statusCode: ErrorType.NOT_FOUND, message: e.message })
        return
      }

      error({ statusCode: ErrorType.SERVER_ERROR, message: e.message })
    }
  },
  computed: {
    eventId(): number {
      return parseInt(this.$route.params['eventId'], 10)
    }
  }
})
